import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Media } from '../board/Media';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  fullScreenFlag:boolean=false;
  flagForSeemore:boolean=false;
  cardId:number=0;
  sectionId:number=0
  boardIdFromGame:number=0;
  loaderFlag:boolean=true;
  user;
  userId:number;
  userName:string=""
  name="";
  tokenForReload;
  

//production
//  url="https://rlboardprod.azurewebsites.net/"
logOutUrl="https://reallivesworld.com/login"
// azureContainerName="real-board-media-prod"


//Development
// url="http://localhost:7071/";
 url="https://realboard.azurewebsites.net/"
//  logOutUrl="https://dev.reallivesworld.com/login"
 azureContainerName="real-board-media"

// static
 selectedlang="en"
 azurStoragUrl="https://realboard.blob.core.windows.net/"
  azureSasKey='';
  homeFlag:Boolean=false;
  analyticalBoardClick:boolean=false;
  boardFlag:boolean=true
  sanitizedHtmlContent: SafeHtml;
  thumbsUpCount;
  selectedMedia=[];
  elem:any;
  maxImageSize=5
  maxVideoSize=100
  maxAudioSize=10
  maxFileSize=10

  /** Dark is the default — users arrive from the simulation. */
  isDarkMode = true;
  private readonly themeStorageKey = 'rl-board-theme';

  constructor(@Inject(DOCUMENT) private document,private sanitizer: DomSanitizer,public http:HttpClient) {
    this.initTheme();
  }

  initTheme() {
    const stored = localStorage.getItem(this.themeStorageKey);
    this.isDarkMode = stored !== 'light';
    this.applyTheme();
  }

  toggleTheme() {
    this.isDarkMode = !this.isDarkMode;
    localStorage.setItem(this.themeStorageKey, this.isDarkMode ? 'dark' : 'light');
    this.applyTheme();
  }

  applyTheme() {
    const root = this.document?.documentElement;
    if (!root) {
      return;
    }
    root.setAttribute('data-theme', this.isDarkMode ? 'dark' : 'light');
    root.style.colorScheme = this.isDarkMode ? 'dark' : 'light';
  }


  getBordValidToken(user_session){
    return this.http.get<any>(`${this.url}api/generate-jwt?user_session=${encodeURIComponent(user_session)}`);
  }

  applySessionUser(raw: any): any {
    const user = this.normalizeSessionUser(raw);
    this.user = user;
    this.userId = user.id;
    this.userName = user.username || '';
    this.name = user.name || '';
    return user;
  }

  normalizeSessionUser(raw: any): any {
    if (!raw) {
      return raw;
    }
    const role = Array.isArray(raw.roles) && raw.roles.length ? raw.roles[0] : {};
    const id = raw.id || raw._id || raw.userId || '';
    const email = raw.email || '';
    const emailName = email.includes('@') ? email.split('@')[0] : '';
    const name = (raw.name || [raw.firstname, raw.lastname].filter(Boolean).join(' ').trim() || emailName || '').trim();
    const username = raw.username || emailName || name;
    const avatar = raw.avatar || raw.avatarUrl || (name
      ? `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=random`
      : '');
    return {
      ...raw,
      id,
      _id: raw._id || id,
      userId: raw.userId || id,
      name,
      username,
      firstname: raw.firstname || name,
      lastname: raw.lastname || '',
      email,
      avatar,
      avatarUrl: raw.avatarUrl || avatar,
      drole: raw.drole || role.drole || '',
      sch_name: raw.sch_name || role.sch_name || role.tenantName || '',
      permissions: raw.permissions || role.permissions || ''
    };
  }

  getSanitizeHtml(text){
    this.sanitizedHtmlContent=this.sanitizer.bypassSecurityTrustHtml(text);
    return this.sanitizedHtmlContent
    
  }
  removeHTMLTags(input: string): string {
    if (input == null || input === undefined) {
      return '';
    }
    return String(input).replace(/<[^>]*>/g, '');
  }
  truncateHTML(text: string,charLimit:any): string {
    let charlimit = charLimit;
    if(!text || text.length <= charlimit )
    {
        return text;
    }
  let without_html = text.replace(/<(?:.|\n)*?>/gm, '');
  let shortened = without_html.substring(0, charlimit);
  return shortened;

  }

  increment() {
    this.thumbsUpCount++;
  }
  
  decrement() {
    if (this.thumbsUpCount > 0) {
      this.thumbsUpCount--;
    }
  }
 createMediaArray(media){
  this.selectedMedia=[];
    media.forEach(media=>{
  if(media.hasOwnProperty('edit')){
    if(!media.edit){
      let dummy: Media = {
        type: media.type,
        url: media.url,
        name:media.name,isPlaying:false 
        };
        this.selectedMedia.push(dummy)
    }
  }
  
})
return this.selectedMedia;
 }



 extractTextFromEditor(editorContent: any): string {
  let textContent = '';
  if (editorContent && editorContent.content) {
    editorContent.content.forEach((content: any) => {
      if (content.type === 'paragraph' && content.content) {
        content.content.forEach((subContent: any) => {
          if (subContent.type === 'text') {
            textContent += subContent.text;
          }
        });
      }
    });
  }
  return textContent;
}




calculateHours(oldTimedtamp){
  let diff,title;
  const timestamp = new Date(oldTimedtamp);
  const currentDate = new Date();
  const differenceMs = currentDate.getTime() - timestamp.getTime();

  const diffMinutes = Math.floor(differenceMs / (1000 * 60));
  const diffHours = Math.floor(differenceMs / (1000 * 60 * 60));
  const diffDays = Math.floor(differenceMs / (1000 * 60 * 60 * 24));
  const diffMonths = Math.floor(differenceMs / (1000 * 60 * 60 * 24 * 30.44)); // Average days in a month
  const diffYears = Math.floor(differenceMs / (1000 * 60 * 60 * 24 * 365.25)); // Average days in a year considering leap years
 if (diffYears >= 1) {
    diff = diffYears;
    title = "yr";
    if (diff > 1) title;
  } else if (diffMonths >= 1) {
    diff = diffMonths;
    title = "mo";
    if (diff > 1) title ;
  } else if (diffDays >= 1) {
    diff = diffDays;
    title = "d";
    if (diff > 1) title ;
  } else if (diffHours >= 1) {
    diff = diffHours;
    title = "h";
    if (diff > 1) title ;
  } else {
    diff = diffMinutes;
    title = "m";
    if (diff > 1) title ;
  }
  if(diff===-1){
    diff=0
  }
return diff+" "+title
}



toggleFullscreen() {
  this.fullScreenFlag=true;
  this.elem = document.documentElement;
  if (this.elem.requestFullscreen) {
    this.elem.requestFullscreen().catch(err => {
      console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
    });
  } else if (this.elem.mozRequestFullScreen) { /* Firefox */
    this.elem.mozRequestFullScreen().catch(err => {
      console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
    });
  } else if (this.elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
    this.elem.webkitRequestFullscreen().catch(err => {
      console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
    });
  } else if (this.elem.msRequestFullscreen) { /* IE/Edge */
    this.elem.msRequestFullscreen().catch(err => {
      console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
    });
    }
}

exitFullScreen() {
  this.fullScreenFlag=false;
  if (this.document.exitFullscreen) {
    this.document.exitFullscreen();
  } else if (this.document.mozCancelFullScreen) {
    /* Firefox */
    this.document.mozCancelFullScreen();
  } else if (this.document.webkitExitFullscreen) {
    /* Chrome, Safari and Opera */
    this.document.webkitExitFullscreen();
  } else if (this.document.msExitFullscreen) {
    /* IE/Edge */
    this.document.msExitFullscreen();
  }
}


removeToken(){
  localStorage.removeItem('token')
}

 checkConditionAndAddClass(condition) {
  if (condition) {
    document.body.classList.add('homeViewClass');
  } else {
    document.body.classList.remove('homeViewClass');
  }
}
}


